var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import ErrorSmall from 'wix-ui-icons-common/on-stage/ErrorSmall';
import { classes, st } from './ErrorMessageWrapper.st.css';
import { ErrorMessageWrapperDataHooks, } from './types';
var ErrorMessageWrapper = /** @class */ (function (_super) {
    __extends(ErrorMessageWrapper, _super);
    function ErrorMessageWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._getMessage = function () {
            var _a = _this.props, message = _a.message, messageId = _a.messageId;
            return (React.createElement("div", { id: messageId, className: classes.message, "data-hook": ErrorMessageWrapperDataHooks.Message },
                React.createElement(ErrorSmall, { className: classes.icon, "aria-hidden": true }),
                message));
        };
        return _this;
    }
    ErrorMessageWrapper.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, visible = _a.visible, suffixText = _a.suffixText, dataHook = _a["data-hook"];
        return (React.createElement("div", { className: st(classes.root, { visible: visible }, className), "data-hook": dataHook },
            children,
            visible &&
                (suffixText ? (React.createElement("div", { className: classes.messageWithSuffix },
                    this._getMessage(),
                    suffixText)) : (this._getMessage()))));
    };
    ErrorMessageWrapper.displayName = 'ErrorMessageWrapper';
    ErrorMessageWrapper.defaultProps = { visible: false };
    return ErrorMessageWrapper;
}(React.Component));
export { ErrorMessageWrapper };
//# sourceMappingURL=ErrorMessageWrapper.js.map